package ai.jessie.web.pages

import ai.jessie.web.authentication.AuthenticationSessionState
import ai.jessie.web.authentication.LocalAuthenticationSessionPort
import ai.jessie.web.authentication.authenticationSection
import ai.jessie.web.theme.entryFrame
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.isExporting
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Page
@Composable
fun supportPage() {
    val port = LocalAuthenticationSessionPort.current
    val scope = rememberCoroutineScope()
    val session = remember(port, scope) { AuthenticationSessionState(port, scope) }
    LaunchedEffect(session) { if (!AppGlobals.isExporting) session.refresh() }
    entryFrame("Hilfe und Kontakt", authenticationRequired = true) {
        P { Text("Wir helfen dir bei Fragen zur Einrichtung und zum Organisationszugriff.") }
        P { A(href = "mailto:support@jessie.ai") { Text("support@jessie.ai") } }
        P { A(href = "/") { Text("Zurück zu Jessie") } }
        authenticationSection(null, session.state, session.actions)
    }
}
